import Backbone from 'backbone';

Backbone.Collection.prototype.save = function(options) {
	return Backbone.sync('create', this, options);
};